"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateTeamBudgetMutation = exports.useEditTeamBudgetMutation = exports.useGetBudgetUtilizationByUserIdQuery = exports.budgets = exports.budgetListEntityAdapter = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toolkit = require("@reduxjs/toolkit");

var _EmptyGatewayApi = require("../../EmptyGatewayApi");

var _helpers = require("./helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var budgetListEntityAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(budget) {
    return budget.teamId;
  }
});
exports.budgetListEntityAdapter = budgetListEntityAdapter;

var budgets = _EmptyGatewayApi.emptyGatewayApi.enhanceEndpoints({
  addTagTypes: ['Utilization']
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getBudgetUtilizationByUserId: build.query({
        query: function query(_ref) {
          var userId = _ref.userId;
          return "/budget/user/".concat(userId, "/utilization");
        },
        transformResponse: function transformResponse(response) {
          var processedResponse = response.data.map(function (utilization) {
            return _objectSpread(_objectSpread({}, utilization), {}, {
              budgetAmount: utilization.budgetAmount / 100,
              availableBudgetAmount: utilization.availableBudgetAmount / 100,
              pendingGiftAmount: utilization.pendingGiftAmount / 100
            });
          });
          return budgetListEntityAdapter.addMany(budgetListEntityAdapter.getInitialState(), processedResponse);
        },
        providesTags: ['Utilization']
      }),
      createTeamBudget: build.mutation({
        query: function query(_ref2) {
          var teamId = _ref2.teamId,
              body = _ref2.body;
          return {
            url: "/budget/team/".concat(teamId),
            method: 'POST',
            body: (0, _helpers.convertBudgetToCents)(body)
          };
        },
        invalidatesTags: ['Utilization']
      }),
      editTeamBudget: build.mutation({
        query: function query(_ref3) {
          var teamId = _ref3.teamId,
              body = _ref3.body;
          return {
            url: "/budget/team/".concat(teamId),
            method: 'PUT',
            body: (0, _helpers.convertBudgetToCents)(body)
          };
        },
        invalidatesTags: ['Utilization']
      })
    };
  }
});

exports.budgets = budgets;
var useGetBudgetUtilizationByUserIdQuery = budgets.useGetBudgetUtilizationByUserIdQuery,
    useEditTeamBudgetMutation = budgets.useEditTeamBudgetMutation,
    useCreateTeamBudgetMutation = budgets.useCreateTeamBudgetMutation;
exports.useCreateTeamBudgetMutation = useCreateTeamBudgetMutation;
exports.useEditTeamBudgetMutation = useEditTeamBudgetMutation;
exports.useGetBudgetUtilizationByUserIdQuery = useGetBudgetUtilizationByUserIdQuery;